import React, { useState, useEffect } from 'react';
import './EmployeeForm.css';
import PersonalDevelopment from './PersonalDevelopment';

const EmployeeForm = ({ employee, onSave, onClose, matrixCategories }) => {
  const [formData, setFormData] = useState({
    name: '',
    position: '',
    category: '核心人才',
    skills: '',
    idpGoals: '',
    idpProgress: '',
    performance: '',
    potential: '',
    history: [],
    notes: ''
  });

  useEffect(() => {
    if (employee) {
      setFormData({
        ...employee,
        history: employee.history || []
      });
    }
  }, [employee]);

  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (employee && employee.category !== formData.category) {
      const newHistory = [...formData.history, {
        date: new Date().toISOString(),
        fromCategory: employee.category,
        toCategory: formData.category,
        reason: formData.notes
      }];
      
      onSave({
        ...formData,
        history: newHistory,
        notes: ''
      });
    } else {
      onSave({
        ...formData,
        id: employee?.id || Date.now()
      });
    }
    onClose();
  };

  return (
    <div className="modal-overlay">
      <div className="employee-form">
        <h2>{employee ? '编辑员工信息' : '添加新员工'}</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>姓名</label>
            <input
              type="text"
              value={formData.name}
              onChange={(e) => setFormData({...formData, name: e.target.value})}
              required
            />
          </div>

          <div className="form-group">
            <label>职位</label>
            <input
              type="text"
              value={formData.position}
              onChange={(e) => setFormData({...formData, position: e.target.value})}
              required
            />
          </div>

          <div className="form-group">
            <label>类别</label>
            <select
              value={formData.category}
              onChange={(e) => setFormData({...formData, category: e.target.value})}
            >
              {matrixCategories.flat().map(category => (
                <option key={category.name} value={category.name}>
                  {category.name} ({category.description})
                </option>
              ))}
            </select>
          </div>

          <div className="form-group">
            <label>技能特长</label>
            <textarea
              value={formData.skills}
              onChange={(e) => setFormData({...formData, skills: e.target.value})}
            />
          </div>

          <div className="form-group">
            <label>IDP目标</label>
            <textarea
              value={formData.idpGoals}
              onChange={(e) => setFormData({...formData, idpGoals: e.target.value})}
            />
          </div>

          <div className="form-group">
            <label>IDP进展</label>
            <textarea
              value={formData.idpProgress}
              onChange={(e) => setFormData({...formData, idpProgress: e.target.value})}
            />
          </div>

          {employee && formData.history && formData.history.length > 0 && (
            <div className="form-group history-section">
              <label>发展历程</label>
              <div className="history-list">
                {formData.history.map((record, index) => (
                  <div key={index} className="history-item">
                    <div className="history-date">
                      {new Date(record.date).toLocaleDateString('zh-CN')}
                    </div>
                    <div className="history-content">
                      从 <strong>{record.fromCategory}</strong> 
                      调整为 <strong>{record.toCategory}</strong>
                    </div>
                    {record.reason && (
                      <div className="history-reason">
                        原因：{record.reason}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}

          {employee && (
            <div className="form-group">
              <label>调整原因</label>
              <textarea
                value={formData.notes}
                onChange={(e) => setFormData({...formData, notes: e.target.value})}
                placeholder="请输入类别调整的原因..."
              />
            </div>
          )}

          {employee && (
            <div className="development-section">
              <PersonalDevelopment 
                employee={employee}
                matrixCategories={matrixCategories}
              />
            </div>
          )}

          <div className="form-buttons">
            <button type="submit" className="save-button">保存</button>
            <button type="button" className="cancel-button" onClick={onClose}>取消</button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default EmployeeForm; 